import React from 'react';
import PropTypes from 'prop-types';
import MaterialUITypography from '../Typography';

const Body2 = ({
  children, tag, className, variant, ...properties
}) => (
  <MaterialUITypography
    tag={tag}
    className={className}
    variant={variant}
    color="textSecondary"
    {...properties}
  >
    {children}
  </MaterialUITypography>
);

Body2.defaultProps = {
  children: undefined,
  tag: 'p',
  variant: 'body2',
  className: undefined,
};

Body2.propTypes = {
  /** Sets the content */
  children: PropTypes.node,
  /** Change the default html tag */
  tag: PropTypes.string,
  /** Sets the classname */
  className: PropTypes.string,
  /**  Applies the theme typography styles * */
  variant: PropTypes.string,
};

export default Body2;
